/* ================================================================
   allCourseForBuy.js
   FIX: All image paths now use filename-only format so that
   getCourseImage() in Shop.jsx can resolve them via require.context.
   Paths like "assets/images/courses/..." were silently failing.
   ================================================================ */

export const allCourseForBuy = [
  {
    segment_id: "1",
    segment: "K12",
    program: [
      {
        program_title: "Digital SAT",
        course: [
          {
            id: "0",
            uniqueID: "100",
            menuName: "Digital SAT",
            image: "Digital SAT.jpg",
            details:
              "EduTechEx Digital SAT is designed by subject matter experts and senior counselors having more than a decade experience in teaching SAT programs worldwide and counselling thousands of students to get admitted into their dream universities worldwide.",
            qtyTotal: 0,
          },
        ],
      },
      {
        program_title: "Advanced Placement",
        course: [
          {
            id: "1",
            uniqueID: "101",
            menuName: "AP Biology",
            image: "AP Biology.jpg",
            details:
              "Advanced Placement examinations (AP exams) are exams offered in the United States by the College Board and are taken each May by students. At many colleges and universities, a high enough score will earn the student college credit. In some instances, earning college credit can mean an overall lower college tuition fee. AP gives students the chance to tackle college-level work while they're still in high school—whether they're learning online or in the classroom.",
            qtyTotal: 0,
          },
          {
            id: "2",
            uniqueID: "102",
            menuName: "AP Calculus AB",
            image: "AP Calculus AB.jpg",
            details:
              "Advanced Placement examinations (AP exams) are exams offered in the United States by the College Board and are taken each May by students. At many colleges and universities, a high enough score will earn the student college credit. AP gives students the chance to tackle college-level work while they're still in high school—whether they're learning online or in the classroom.",
            qtyTotal: 0,
          },
          {
            id: "3",
            uniqueID: "103",
            menuName: "AP Calculus BC",
            image: "AP Calculus BC.jpg",
            details:
              "Advanced Placement examinations (AP exams) are exams offered in the United States by the College Board and are taken each May by students. At many colleges and universities, a high enough score will earn the student college credit. AP gives students the chance to tackle college-level work while they're still in high school—whether they're learning online or in the classroom.",
            qtyTotal: 0,
          },
          {
            id: "4",
            uniqueID: "104",
            menuName: "AP Physics 1",
            subTitle: "Algebra-Based",
            image: "AP Physics 1.jpg",
            details:
              "Advanced Placement examinations (AP exams) are exams offered in the United States by the College Board and are taken each May by students. At many colleges and universities, a high enough score will earn the student college credit. AP gives students the chance to tackle college-level work while they're still in high school—whether they're learning online or in the classroom.",
            qtyTotal: 0,
          },
          {
            id: "5",
            uniqueID: "105",
            menuName: "AP Physics 2",
            subTitle: "Algebra-Based",
            image: "AP Physics 2-07.jpg",
            details:
              "Advanced Placement examinations (AP exams) are exams offered in the United States by the College Board and are taken each May by students. At many colleges and universities, a high enough score will earn the student college credit. AP gives students the chance to tackle college-level work while they're still in high school—whether they're learning online or in the classroom.",
            qtyTotal: 0,
          },
          {
            id: "6",
            uniqueID: "106",
            menuName: "AP Physics C",
            subTitle: "Electricity and Magnetism",
            image: "AP Physics C.jpg",
            details:
              "Advanced Placement examinations (AP exams) are exams offered in the United States by the College Board and are taken each May by students. At many colleges and universities, a high enough score will earn the student college credit. AP gives students the chance to tackle college-level work while they're still in high school—whether they're learning online or in the classroom.",
            qtyTotal: 0,
          },
          {
            id: "7",
            uniqueID: "107",
            menuName: "AP Physics C",
            subTitle: "Mechanics",
            image: "AP Physics C 02.jpg",
            details:
              "Advanced Placement examinations (AP exams) are exams offered in the United States by the College Board and are taken each May by students. At many colleges and universities, a high enough score will earn the student college credit. AP gives students the chance to tackle college-level work while they're still in high school—whether they're learning online or in the classroom.",
            qtyTotal: 0,
          },
          {
            id: "8",
            uniqueID: "108",
            menuName: "AP Chemistry",
            image: "AP Chemistry.jpg",
            details:
              "Advanced Placement examinations (AP exams) are exams offered in the United States by the College Board and are taken each May by students. At many colleges and universities, a high enough score will earn the student college credit. AP gives students the chance to tackle college-level work while they're still in high school—whether they're learning online or in the classroom.",
            qtyTotal: 0,
          },
          {
            id: "9",
            uniqueID: "109",
            menuName: "AP Macroeconomics",
            image: "Macroeconomics.jpg",
            details:
              "Advanced Placement examinations (AP exams) are exams offered in the United States by the College Board and are taken each May by students. At many colleges and universities, a high enough score will earn the student college credit. AP gives students the chance to tackle college-level work while they're still in high school—whether they're learning online or in the classroom.",
            qtyTotal: 0,
          },
          {
            id: "10",
            uniqueID: "110",
            menuName: "AP Microeconomics",
            image: "Microeconomics.jpg",
            details:
              "Advanced Placement examinations (AP exams) are exams offered in the United States by the College Board and are taken each May by students. At many colleges and universities, a high enough score will earn the student college credit. AP gives students the chance to tackle college-level work while they're still in high school—whether they're learning online or in the classroom.",
            qtyTotal: 0,
          },
        ],
      },
      {
        program_title: "Ivy League Bachelors Program",
        course: [
          {
            id: "0",
            uniqueID: "301",
            menuName: "Ivy League Bachelors Program",
            image: "Ivy.jpg",
            details:
              "A foundation course is a programme that will prepare you for an undergraduate degree at university.",
            qtyTotal: 0,
          },
        ],
      },
      {
        program_title: "Medical Program",
        course: [
          {
            id: "1",
            uniqueID: "401",
            menuName: "NEET – Medical Program in India",
            image: "ind.png",
            details:
              "NEET – UG is the single examination conducted for aspirants seeking admission in top medical colleges for MBBS and BDS.",
            qtyTotal: 0,
          },
          {
            id: "2",
            uniqueID: "402",
            menuName: "Medical Program – United Kingdom",
            image: "uk.png",
            details:
              "Medicine is one of the most competitive courses in the UK, but thousands of international students are accepted every year.",
            qtyTotal: 0,
          },
          {
            id: "3",
            uniqueID: "403",
            menuName: "Medical Program – United States of America",
            /* FIX: was "assets/images/flags/usa.png" — won't resolve via
               require.context("../../assets/buycourses"). Corrected to
               filename only. Make sure usa.png is in assets/buycourses/. */
            image: "usa.png",
            details:
              "The MBBS curriculum in the USA is challenging, and therefore, rewarding for the graduates.",
            qtyTotal: 0,
          },
        ],
      },
      {
        program_title: "Indian Entrance Prep",
        course: [
          {
            id: "9",
            uniqueID: "201",
            menuName: "JEE Mains & Advanced Program",
            image: "Indian Entrance Prep.jpg",
            details:
              "JEE Main is the first phase of the IIT Joint Entrance Exam (IIT JEE). It is a computer-based online test conducted by National Testing Agency for students aspiring to pursue undergraduate courses in India in top engineering institutes, such as IITs, NITs, etc.",
            qtyTotal: 0,
          },
          {
            id: "10",
            uniqueID: "202",
            menuName: "BITSAT Program",
            image: "Indian Entrance Prep.jpg",
            details:
              "BITS Pilani provides three tier education system: First Degree, Higher Degree and Ph.D.",
            qtyTotal: 0,
          },
          {
            id: "11",
            uniqueID: "203",
            menuName: "CLAT Program",
            image: "Indian Entrance Prep.jpg",
            details:
              "The Common Law Admission Test (CLAT) is a centralized national level entrance test for admissions to twenty two National Law Universities (NLU) in India.",
            qtyTotal: 0,
          },
        ],
      },
      {
        program_title: "Career Navigation",
        course: [
          {
            id: "1",
            uniqueID: "601",
            menuName: "Career Navigation",
            image: "Career Counselling.jpg",
            details:
              "For Grade 6 to 12th students from all International (IB, Cambridge IGCSE) and Indian (CBSE, State, ICSE) based curriculums.",
            qtyTotal: 0,
          },
        ],
      },
      {
        program_title: "After School Services",
        course: [
          {
            id: "1",
            uniqueID: "701",
            menuName: "Grade 9 After School Program",
            image: "After School Prep Banner.jpg",
            details:
              "Our After School Programs are meticulously designed for students to excel in Math, Science and English providing a strong foundation for competitive exams.",
            qtyTotal: 0,
          },
          {
            id: "2",
            uniqueID: "702",
            menuName: "Grade 9 After School Program",
            image: "After School Prep Banner.jpg",
            details:
              "Our After School Programs are meticulously designed for students to excel in Math, Science and English providing a strong foundation for competitive exams.",
            qtyTotal: 0,
          },
          {
            id: "3",
            uniqueID: "703",
            menuName: "Grade 10 After School Program",
            image: "After School Prep Banner.jpg",
            details:
              "Our After School Programs are meticulously designed for students to excel in Math, Science and English providing a strong foundation for competitive exams.",
            qtyTotal: 0,
          },
          {
            id: "4",
            uniqueID: "704",
            menuName: "Grade 10 After School Program",
            image: "After School Prep Banner.jpg",
            details:
              "Our After School Programs are meticulously designed for students to excel in Math, Science and English providing a strong foundation for competitive exams.",
            qtyTotal: 0,
          },
          {
            id: "5",
            uniqueID: "705",
            menuName: "Grade 11 After School Program",
            image: "After School Prep Banner.jpg",
            details:
              "Our After School Programs are meticulously designed for students to excel in Math, Science and English providing a strong foundation for competitive exams.",
            qtyTotal: 0,
          },
          {
            id: "6",
            uniqueID: "706",
            menuName: "Grade 11 After School Program",
            image: "After School Prep Banner.jpg",
            details:
              "Our After School Programs are meticulously designed for students to excel in Math, Science and English providing a strong foundation for competitive exams.",
            qtyTotal: 0,
          },
          {
            id: "7",
            uniqueID: "707",
            menuName: "Grade 12 After School Program",
            image: "After School Prep Banner.jpg",
            details:
              "Our After School Programs are meticulously designed for students to excel in Math, Science and English providing a strong foundation for competitive exams.",
            qtyTotal: 0,
          },
          {
            id: "8",
            uniqueID: "708",
            menuName: "Grade 12 After School Program",
            image: "After School Prep Banner.jpg",
            details:
              "Our After School Programs are meticulously designed for students to excel in Math, Science and English providing a strong foundation for competitive exams.",
            qtyTotal: 0,
          },
        ],
      },
    ],
  },
  {
    segment_id: "2",
    segment: "Undergraduate",
    program: [
      {
        program_title: "Abroad Masters Placement",
        course: [
          {
            id: "1",
            uniqueID: "01",
            menuName: "Abroad Masters Placement",
            /* FIX: was "assets/images/courses/Abroad Masters Placement.jpg"
               Corrected to filename only. Ensure file is in assets/buycourses/. */
            image: "Abroad Masters Placement.jpg",
            details:
              "Abroad Masters program enables students who are about to and have completed UG degrees to get admitted into the top universities around the world aligned with their passion.",
            qtyTotal: "0",
          },
        ],
      },
      {
        program_title: "Abroad Transfers Program",
        course: [
          {
            id: "2",
            uniqueID: "02",
            menuName: "Abroad Transfers Program",
            image: "Abroad Masters Placement.jpg",
            details:
              "Abroad Exchange program enables students who are in the first year of their undergraduate courses to get admitted into the top universities around the world.",
            qtyTotal: "0",
          },
        ],
      },
    ],
  },
  {
    segment_id: "3",
    segment: "Postgraduate",
    program: [
      {
        program_title: "Abroad Ph.D. Program",
        course: [
          {
            id: "1",
            uniqueID: "03",
            menuName: "Abroad Ph.D. Program",
            /* FIX: was "assets/images/courses/Abroad Ph.D. Program.jpg" */
            image: "Abroad Ph.D. Program.jpg",
            details:
              "Abroad Ph.D. program enables students and working professionals who have completed their UG and PG and motivated to pursue doctoral research in some of the cutting edge technological, innovative and creative areas.",
            qtyTotal: "0",
          },
        ],
      },
    ],
  },
];